import Vue from 'vue'

//import AddToGroupForm from './AddToGroupForm.vue'
import AppForm from './AppForm.vue'
import DateTimeSelector from './DateTimeSelector.vue'
import FeatureDisabled from './FeatureDisabled.vue'
import FormFieldSelector from './FormFieldSelector.vue'
import FormSubmission from './FormSubmission.vue'
import GroupRemovalForm from './GroupRemovalForm'
import HelpModal from './HelpModal.vue'
import HotKeysPopUp from './HotKeysPopUp.vue'
import IList from './IList.vue'
import IListAction from './IListAction.vue'
import IListFilterSelect from './IListFilterSelect.vue'
import IListMultiSelect from './IListMultiSelect.vue'
import IListPlaceholder from './IListPlaceholder'
import IListTile from './IListTile'
import IToolbar from './IToolbar.vue'
import MainPageTemplate from './MainPageTemplate.vue'
import MessageTextForm from './MessageTextForm.vue'
import MessageTextFormSave from './MessageTextFormSave.vue'
import PageTemplate from './PageTemplate.vue'
import PersonMap from './PersonMap.vue'
import PersonShowItem from './PersonShowItem.vue'
import StripePaymentCard from './StripePaymentCard.vue'
import TeammatesEmpty from './TeammatesEmpty.vue'
import ToolbarTitle from './ToolbarTitle.vue'
import TriPanelButton from './TriPanelButton.vue'
import TriPanelTools from './TriPanelTools.vue'

//Vue.component('add-to-group-form', AddToGroupForm)
Vue.component('app-form', AppForm)
Vue.component('date-time-selector', DateTimeSelector)
Vue.component('feature-disabled', FeatureDisabled)
Vue.component('form-field-selector', FormFieldSelector)
Vue.component('form-submission', FormSubmission)
Vue.component('group-removal-form', GroupRemovalForm)
Vue.component('help-modal', HelpModal)
Vue.component('hot-keys-pop-up', HotKeysPopUp)
Vue.component('i-list', IList)
Vue.component('i-list-action', IListAction)
Vue.component('i-list-filter-select', IListFilterSelect)
Vue.component('i-list-multi-select', IListMultiSelect)
Vue.component('i-list-placeholder', IListPlaceholder)
Vue.component('i-list-tile', IListTile)
Vue.component('i-toolbar', IToolbar)
Vue.component('main-page-template', MainPageTemplate)
Vue.component('message-text-form', MessageTextForm)
Vue.component('message-text-form-save', MessageTextFormSave)
Vue.component('page-template', PageTemplate)
Vue.component('person-map', PersonMap)
Vue.component('person-show-item', PersonShowItem)
Vue.component('stripe-payment-card', StripePaymentCard)
Vue.component('teammates-empty', TeammatesEmpty)
Vue.component('toolbar-title', ToolbarTitle)
Vue.component('tri-panel-button', TriPanelButton)
Vue.component('tri-panel-tools', TriPanelTools)
